import { useQuery } from '@tanstack/react-query';

import { getMemberTimeOffRequestDetails } from '../api/member-time-offs.api';
import { getMemberTimeOffRequestDetailsQueryKey } from '../constants/member-time-offs-query-keys';

const MEMBER_TIME_OFF_REQUEST_DETAILS_STALE_TIME = 5 * 60 * 1000;

/**
 * Fetches a single team member's time-off request details. Swagger currently
 * exposes only the shared request details endpoint, while the memberId remains
 * part of the query key so manager reads stay cached per viewed member.
 */
export const useMemberTimeOffRequestDetails = (
  memberId: string | undefined,
  requestId: number | undefined
) => {
  const isEnabled = !!memberId && typeof requestId === 'number' && !Number.isNaN(requestId);

  return useQuery({
    queryKey: getMemberTimeOffRequestDetailsQueryKey(memberId ?? '', requestId ?? 0),
    queryFn: () =>
      getMemberTimeOffRequestDetails({
        memberId: memberId as string,
        requestId: requestId as number,
      }),
    enabled: isEnabled,
    staleTime: MEMBER_TIME_OFF_REQUEST_DETAILS_STALE_TIME,
  });
};
